import React, { useEffect, useState } from "react";
import { Table, Tag, Button, Space, Typography, message } from "antd";
import { ConfirmMorakasiForUser, GetAllMorakasiConfirmForUser } from "../../RestAPI/dbo/Morakasiapi";
import { Morakasi as mo } from "../../Model/dbo/Morakasi";

const { Title } = Typography;

const ConfirmMorakhasi = () => {
  const [data, setParts] = useState<mo[]>([]); // برای ذخیره داده‌ها
  const [loading, setLoading] = useState(false); // برای مدیریت وضعیت بارگذاری

  const handleApprove = async (id: number, personelId: number) => {
    try {
     const s= await ConfirmMorakasiForUser(id, personelId, true);
     if(s==true)
      {
      message.success("درخواست تایید شد");
      fetchData(); // برای به‌روزرسانی داده‌ها
      }
    } catch (error) {
      message.error("خطا در تایید درخواست");
    }
  };

  const handleReject = async (id: number, personelId: number) => {
    try {
     
     const s=await ConfirmMorakasiForUser(id, personelId, false);
      if(s==true)
        {
          message.success("درخواست رد شد");
          fetchData(); // برای به‌روزرسانی داده‌ها
        }
        } catch (error) {
      message.error("خطا در رد درخواست");
    }
  };

  const columns = [
    {
      title: "نام کارمند",
      dataIndex: "FullName",
      key: "FullName",
    },
    {
      title: "تاریخ مرخصی",
      dataIndex: "Date",
      key: "Date",
    },
    {
      title: 'از ساعت',
      dataIndex: 'StartTime',
      key: 'StartTime',
    },
    {
      title: 'تا ساعت',
      dataIndex: 'EndTime',
      key: 'EndTime',
    },
    {
      title: "روز مرخصی",
      dataIndex: "Day",
      key: "Day",
    },
    {
      title: "وضعیت",
      dataIndex: "Status",
      key: "Status",
      render: (status: string) => {
        let color = "blue";
        if (status === "تایید شده") color = "green";
        if (status === "رد شده") color = "red";
        return <Tag color={color}>{status}</Tag>;
      },
    },
    {
      title: "عملیات",
      key: "action",
      render: (_: any, record: mo) => (
        <Space>
          <Button
            type="primary"
            onClick={() => handleApprove(record.ID, record.PersonelID)}
            disabled={record.Status !== "منتظر تایید"}
          >
            تایید
          </Button>
          <Button
            danger
            onClick={() => handleReject(record.ID, record.PersonelID)}
            disabled={record.Status !== "منتظر تایید"}
          >
            رد
          </Button>
        </Space>
      ),
    },
  ];

  const fetchData = async () => {
    setLoading(true);
    try {
      const list = await GetAllMorakasiConfirmForUser();
      setParts(
        list.map((item: mo) => ({
          ...item,
          key: item.ID, // افزودن کلید یونیک
        }))
      );
    } catch (error) {
      message.error("خطا در دریافت داده‌ها");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div style={{ padding: 20 }}>
      <Title level={3}>تایید مرخصی</Title>
      <Table
        scroll={{ x: "max-content" }}
        columns={columns}
        dataSource={data}
        bordered
        loading={loading}
      />
    </div>
  );
};

export default ConfirmMorakhasi;
